/* unplugin-vue-components disabled */import script from "./DebtCount.vue?vue&type=script&setup=true&lang=js"
export * from "./DebtCount.vue?vue&type=script&setup=true&lang=js"

import "./DebtCount.vue?vue&type=style&index=0&id=2ff6b065&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff6b065"]])

export default __exports__